import { useState } from "react";
import FilterBar from "./FilterBar";
import TimelineView from "./TimelineView";
import TableView from "./TableView";


const mockCycles = [
  {
    id: 1,
    label: "April 2025 GST Return",
    dueDate: "2025-05-20",
    status: "Completed",
    assignedTo: "Amit",
    clientPending: false
  },
  {
    id: 2,
    label: "May 2025 GST Return",
    dueDate: "2025-06-20",
    status: "In Progress",
    assignedTo: "Neha",
    clientPending: true
  },
  {
    id: 3,
    label: "June 2025 GST Return",
    dueDate: "2025-07-20",
    status: "Pending",
    assignedTo: "Ravi",
    clientPending: false
  }
];

const ComplianceCalendar = () => {
  const [view, setView] = useState("timeline");
  const [statusFilter, setStatusFilter] = useState("All");

  const filtered = mockCycles.filter(c =>
    statusFilter === "All" ? true : c.status === statusFilter
  );

  return (
    <div>
      <FilterBar
        view={view}
        setView={setView}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
      />

      {view === "timeline" && <TimelineView cycles={filtered} />}
      {view === "table" && <TableView cycles={filtered} />}
    </div>
  );
};

export default ComplianceCalendar;
